<template>
	<div>
		<scale-notification
			v-if="props.show"
			class="notification"
			:opened="props.show"
			:variant="props.variant"
			:heading="props.title"
			:dismissible="props.variant === 'success' ? false : true"
			@scale-close="emitCloseClick"
		>
			<!-- Text -->
			<div v-if="props.text"
				slot="text">
				<p class="ma-0"
					v-for="(textLine, index) in props.text"
					:key="index">
					{{ textLine }}
				</p>
			</div>
		</scale-notification>
	</div>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  // Define props
  const props = defineProps({
    show: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: Array,
      required: false
    },
    variant: {
      type: String,
      default: 'informational',
      validator(value) {
        return ['danger', 'success', 'informational'].includes(value);
      }
    }
  });

  // Define emits
  const emit = defineEmits(['close-click']);

  // Method to emit close click event
  const emitCloseClick = () => {
    emit('close-click');
  };
</script>

<style lang="scss" scoped>
.notification {
  position: relative;
}

.div-close-icon-wrapper {
  position: absolute;
  z-index: 1;
  right: 14px;
  top: 7px;
  height: 20px;
  width: 20px;
  padding: 6px;
  cursor: pointer;
  border-radius: 7px;
}

.div-close-icon-wrapper:hover {
  background-color: white;
  
  .close-icon {
    color: rgb(192, 0, 99) !important;
  }
}
</style>
